"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const file_uploader_1 = __importDefault(require("@hotmart-org-ca/file-uploader"));
const Settings_1 = __importDefault(require("configs/Settings"));
const membership_1 = require("modules/membership");
class UploadService {
    static getUploadConfig(entityType, productId, accessToken) {
        return {
            config: {
                url: `${Settings_1.default.api.fileClub}/v4/upload/config`,
                type: entityType
            },
            accessToken,
            system: 'club_admin',
            authParams: { 'x-product-id': productId.toString() }
        };
    }
    static async uploadFile(file, productId, entityType, accessToken) {
        const config = this.getUploadConfig(entityType, productId, accessToken);
        return new Promise((resolve, reject) => {
            const onSuccess = (data) => {
                resolve(data.id);
            };
            const onFailure = (error) => {
                reject(error);
            };
            file_uploader_1.default.setCallbackSuccess(onSuccess)
                .setCallbackFailure(onFailure)
                .build(config, false)
                .then((uploader) => {
                return uploader.send(file, {
                    metaData: {
                        subdomain: membership_1.MembershipStore.subdomain,
                        membershipOwnerId: membership_1.MembershipStore.membershipOwnerHash
                    }
                });
            })
                .catch(onFailure);
        });
    }
    static getPreviewUrl(file) {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.addEventListener('load', () => {
                resolve(fileReader.result);
            });
            fileReader.readAsDataURL(file);
        });
    }
}
exports.default = UploadService;
